// var api = "https://api-dev-elikia-funding.fewnu.app/api/";
// var api = "http://127.0.0.1:8000/api/";
var api = "https://api-recette-elikia-funding.fewnu.app/api/";
// var api = "https://api-easy-funding.fewnu.app/api/";

export default api;